import { FeedbackFab } from '../../components/FeedbackFab'
import { useIsNavCompact } from '../../hooks/useNavCompact'
import { openFeedback } from '../../lib/feedbackBridge'
import { usePeekTip } from '../../lib/nuxTips'
import { cn } from '../../lib/utils'
import { CrewPlansFab } from './CrewPlansFab'

// Home's floating stack — crew filter above feedback — lined up with the schedule's FAB trigger:
// bottom-5 + right-1 inside a grid inset 16px from the nav and the screen edge.
// Both peek their labels on arrival, like the schedule's always-visible tier.
export function HomeFabs({ withCrew, onToggle }: { withCrew: boolean; onToggle: () => void }) {
  const hidden = useIsNavCompact()
  const { peeking, endPeek } = usePeekTip('home_crew_fab_label')

  return (
    <div
      inert={hidden}
      className={cn(
        'fixed right-5 bottom-[calc(var(--bottom-nav-height)+env(safe-area-inset-bottom)+24px)] md:bottom-5 z-45 flex flex-col items-end gap-2 transition-[translate] duration-300 ease-[cubic-bezier(0.22,1,0.36,1)]',
        // The schedule's tuck, but all the way off: past its own width plus the
        // right-5 gutter.
        hidden && 'translate-x-[calc(100%+1.5rem)]',
      )}
    >
      <CrewPlansFab
        withCrew={withCrew}
        peeking={peeking}
        onToggle={() => {
          endPeek()
          onToggle()
        }}
      />
      <FeedbackFab
        showLabel={peeking}
        onClick={() => {
          endPeek()
          openFeedback()
        }}
      />
    </div>
  )
}
